import { axiosGetV3, axiosPost } from '../utils/AxiosApi';
import { URL } from '../utils/Constants';

// Action Types
const FETCH_PORT_LISTS_REQUEST = 'ports/FETCH_PORT_LISTS_REQUEST';
const FETCH_PORT_LISTS_SUCCESS = 'ports/FETCH_PORT_LISTS_SUCCESS';
const FETCH_PORT_LISTS_FAILURE = 'ports/FETCH_PORT_LISTS_FAILURE';
const FETCH_PORTS_BY_TYPE_REQUEST = 'ports/FETCH_PORTS_BY_TYPE_REQUEST';
const FETCH_PORTS_BY_TYPE_SUCCESS = 'ports/FETCH_PORTS_BY_TYPE_SUCCESS';
const FETCH_PORTS_BY_TYPE_FAILURE = 'ports/FETCH_PORTS_BY_TYPE_FAILURE';

// Initial State
const initialState = {
  loading: false,
  error: null,
  airPorts: [],
  seaPorts: [],
  customPointListSea: [],
  customPointListAir: [],
  globalCustomPoint: [],
  portsByType: [],
  portsByTypeLoading: false,
  portsByTypeError: null
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PORT_LISTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PORT_LISTS_SUCCESS:
      return {
        ...state,
        loading: false,
        airPorts: action.payload.airPorts,
        seaPorts: action.payload.seaPorts,
        customPointListSea: action.payload.customPointListSea,
        customPointListAir: action.payload.customPointListAir,
        globalCustomPoint: action.payload.globalCustomPoint,
        error: null
      };

    case FETCH_PORT_LISTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_PORTS_BY_TYPE_REQUEST:
      return {
        ...state,
        portsByTypeLoading: true,
        portsByTypeError: null
      };

    case FETCH_PORTS_BY_TYPE_SUCCESS:
      return {
        ...state,
        portsByTypeLoading: false,
        portsByType: action.payload,
        portsByTypeError: null
      };

    case FETCH_PORTS_BY_TYPE_FAILURE:
      return {
        ...state,
        portsByTypeLoading: false,
        portsByTypeError: action.payload
      };

    default:
      return state;
  }
}

// Action Creators
const fetchPortListsRequest = () => ({ type: FETCH_PORT_LISTS_REQUEST });
const fetchPortListsSuccess = (data) => ({
  type: FETCH_PORT_LISTS_SUCCESS,
  payload: data
});
const fetchPortListsFailure = (error) => ({
  type: FETCH_PORT_LISTS_FAILURE,
  payload: error
});

const fetchPortsByTypeRequest = () => ({ type: FETCH_PORTS_BY_TYPE_REQUEST });
const fetchPortsByTypeSuccess = (ports) => ({
  type: FETCH_PORTS_BY_TYPE_SUCCESS,
  payload: ports
});
const fetchPortsByTypeFailure = (error) => ({
  type: FETCH_PORTS_BY_TYPE_FAILURE,
  payload: error
});

// Thunk Actions
export const fetchPortLists = () => (dispatch) => {
  dispatch(fetchPortListsRequest());

  axiosGetV3(URL.getPortLists)
    .then((res) => {
      const airPorts = res.data.data.airPorts.map((item) => ({
        value: item.id,
        label: item.name
      }));
      const seaPorts = res.data.data.seaPorts.map((item) => ({
        value: item.id,
        label: item.name
      }));
      const airPortsCustom = res.data.data.airPorts.map((item) => ({
        value: item.name,
        label: item.name
      }));
      const seaPortsCustom = res.data.data.seaPorts.map((item) => ({
        value: item.name,
        label: item.name
      }));
      const dryPorts = res.data.data.dryPorts.map((item) => ({
        value: item.name,
        label: `${item.name} (${item.countryCode})`
      }));

      dispatch(
        fetchPortListsSuccess({
          airPorts,
          seaPorts,
          customPointListSea: [...dryPorts, ...seaPortsCustom],
          customPointListAir: airPortsCustom,
          globalCustomPoint: [...airPortsCustom, ...dryPorts, ...seaPortsCustom]
        })
      );
    })
    .catch((err) => {
      dispatch(fetchPortListsFailure(err.message));
    });
};

export const fetchPortsByType = (isAir) => (dispatch) => {
  dispatch(fetchPortsByTypeRequest());

  axiosPost(
    URL.getPortListByFreightType,
    { type: isAir === 'air' ? 'air' : 'sea' },
    (response) => {
      if (response.data.success) {
        dispatch(fetchPortsByTypeSuccess(response.data.data.items));
      } else {
        dispatch(fetchPortsByTypeFailure(response.data.message));
      }
    },
    (err) => {
      dispatch(fetchPortsByTypeFailure(err.message));
    }
  );
};

// Selectors
export const selectAirPorts = (state) => state.ports.airPorts;
export const selectSeaPorts = (state) => state.ports.seaPorts;
export const selectCustomPointListSea = (state) => state.ports.customPointListSea;
export const selectCustomPointListAir = (state) => state.ports.customPointListAir;
export const selectGlobalCustomPoint = (state) => state.ports.globalCustomPoint;
export const selectPortsByType = (state) => state.ports.portsByType;
export const selectPortsLoading = (state) => state.ports.loading;
export const selectPortsError = (state) => state.ports.error;
export const selectPortsByTypeLoading = (state) => state.ports.portsByTypeLoading;
export const selectPortsByTypeError = (state) => state.ports.portsByTypeError;
